/**
 * Badge PERMANENTE su un ordine riassegnato a un altro cliente (R6-C).
 *
 * Non è cosmetico: la riassegnazione lascia l'ordine in uno stato ibrido —
 * i conferimenti seguono il cliente nuovo, mentre i documenti già generati o
 * firmati (preventivo, omologa) e gli XML delle fatture restano intestati al
 * soggetto precedente. Questo badge è ciò che rende quello stato leggibile nel
 * tempo, a chiunque apra l'ordine mesi dopo.
 *
 * Alimentato da `cliente_precedente` (colonne V66), presente su ogni GET del
 * dettaglio, non solo subito dopo il cambio.
 */
import { History } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import type { ClientePrecedenteInline } from '../api/richieste';

function formatDateIT(iso: string): string {
  return new Date(iso).toLocaleDateString('it-IT', { day: '2-digit', month: 'long', year: 'numeric' });
}

export default function BadgeClienteRiassegnato({ precedente }: { precedente: ClientePrecedenteInline }) {
  const { t } = useTranslation();
  return (
    <div
      data-testid="badge-cliente-riassegnato"
      className="flex items-start gap-2.5 px-4 py-3 rounded-lg border border-accent-warning/30 bg-accent-warning-bg text-sm text-ink-dark"
    >
      <History size={16} className="text-accent-warning flex-shrink-0 mt-0.5" />
      <div className="space-y-0.5">
        <p>
          {t('richieste.cambia_cliente.badge.testo', {
            cliente: precedente.ragione_sociale,
            data: formatDateIT(precedente.cambiato_at),
          })}
          {precedente.cambiato_da_nome
            ? ` — ${t('richieste.cambia_cliente.badge.da', { utente: precedente.cambiato_da_nome })}`
            : ''}
        </p>
        <p className="text-xs text-ink-soft">{t('richieste.cambia_cliente.badge.nota_documenti')}</p>
      </div>
    </div>
  );
}
